
import { react_api } from "../../config";



let toast;
let axiosInstance;
let translator;
// Funzione di inizializzazione per configurare le variabili
export const initMaskingHttpService = (translation, t, axiosInst) => {

    
  translator = translation;
  toast = t;
  axiosInstance = axiosInst;
};


  const baseUrl = `${react_api}/services/masking`;
  
export const maskingPdf = async (file, onCompleteToast) => {
  try {
    const formData = new FormData();
    formData.append('file', file);
    formData.append("BearerToken", sessionStorage.getItem("token"));
    formData.append("username", sessionStorage.getItem("username"));

    const response = await axiosInstance.post(`${baseUrl}/pdf`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      responseType: 'blob'
    });

    const blob = new Blob([response.data], { type: 'application/pdf' }); // 👈 fix qui

    toast({
      title: translator('toastMsg.fileMasking.successMessage'),
      status: 'success',
      duration: 1500,
      position: 'top',
      isClosable: true,
      onCloseComplete: onCompleteToast
    });

    return blob;

  } catch (error) {
    toast({
      title: translator('toastMsg.callError'),
      description: String(error),
      status: 'warning',
      duration: 4000,
      position: 'top',
      isClosable: true
    });
  }
};


export const maskingTxt = async (file, onCompleteToast) => {
  try {
    const formData = new FormData();
    formData.append('file', file);
    formData.append("BearerToken",sessionStorage.getItem("token"))
    formData.append("username",sessionStorage.getItem("username"))
    const response = await axiosInstance.post(`${baseUrl}/txt`, formData, {
      headers: {
     
        'Content-Type': 'multipart/form-data'
      },
      responseType: 'blob' // <-- questo è fondamentale
    });

    const blob = response.data;




    
    // Facoltativo: trigger download automatico
   
    toast({
      title: translator('toastMsg.fileMasking.successMessage'),
      status: 'success',
      duration: 1500,
      position: 'top',
      isClosable: true,
      onCloseComplete: onCompleteToast
    });

      return blob;


  } catch (error) {
    toast({
      title: translator('toastMsg.callError'),
      description: String(error),
      status: 'warning',
      duration: 4000,
      position: 'top',
      isClosable: true
    });
  }
};

  

  
  

